// deps
import React, { memo, ReactElement } from "react";

//components
import { SplitPayBannerV4 } from "./v4";

//interface
import {
    SPLITPAY_SELECTION_TYPE,
    SplitpayAnalyticsEvents,
    SplitPayData,
    SwiggyMoneyActions,
} from "@payment-ui/interfaces";

interface SplitPayBannerProps {
    data: SplitPayData;
    handleChange: (isSplitPayChecked: boolean, methodData: SplitPayData) => void;
    isSplitPayChecked: boolean;
    isFrictionLayout?: boolean;
    className?: string;
    paymentGroupBanner?: ReactElement | null;
    addMoneyActions?: SwiggyMoneyActions["addMoneyActions"];
    isAddMoneyCtaDisabled?: boolean;
    swiggyMoneyInfoActions?: SwiggyMoneyActions["swiggyMoneyInfoActions"];
    onFlipkartToolTipShow?: () => void;
    showViewAllRewardsCta?: boolean;
    handleViewAllRewardsClick?: (show: boolean) => void;
    selectionType?: SPLITPAY_SELECTION_TYPE;
    analyticsEvents?: Pick<
        SplitpayAnalyticsEvents,
        | "splitpayClickEvent"
        | "viewAllRewardsCtaClickEvent"
        | "rewardsInHalfcardClickEvent"
        | "viewAllRewardsCtaImpressionEvent"
    >;
}

function SplitPayBanner(props: SplitPayBannerProps): ReactElement {
    return <SplitPayBannerV4 {...props} />;
}

export default memo(SplitPayBanner);
